export default __webpack_public_path__ + "static/media/carbon-trust-charity.01f2a957.jpg";